export const environment = {
  production: false,
  apiUrl: 'https://apiv3.plataformaasap.com.br',
  baseUrl: 'https://apiv3.plataformaasap.com.br',
  filestack: { key: 'AD5oDjsJaTJOzLe1Llj9mz' },
  pusher: { key: 'eaf41725f3b027147953' },
  firebase: {
    apiKey: "AIzaSyBS6vnYry0auS06c3DGZqgpKMVkR-yAAMM",
    authDomain: "plataforma-latam.firebaseapp.com",
    databaseURL: "https://plataforma-latam.firebaseio.com",
    projectId: "plataforma-latam",
    storageBucket: "plataforma-latam.appspot.com",
    messagingSenderId: "1086670277432"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts